import type { Team } from '@/types/company'
import { Input } from '@/components/ui/input'

interface TeamComboboxProps {
  id?: string
  value: string
  teams: Team[]
  disabled?: boolean
  onChange: (value: string) => void
  listId: string
}

// Free-type combobox over existing teams. Empty value = company-wide. A typed new name creates the
// team ad-hoc on submit (server-side find-or-create). Uses a native datalist because the repo has no
// combobox primitive (only dialog is owned under components/ui).
export function TeamCombobox({ id, value, teams, disabled, onChange, listId }: TeamComboboxProps) {
  return (
    <>
      <Input
        id={id}
        type="text"
        list={listId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Company-wide"
        disabled={disabled}
        aria-label="Team"
      />
      <datalist id={listId}>
        {teams.map((team) => (
          <option key={team.id} value={team.name} />
        ))}
      </datalist>
    </>
  )
}
